import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function LegalNotice() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderContent = (text) => {
    return text.split('\n').map((line, index) => {
      const trimmedLine = line.trim();
      if (trimmedLine.match(/^\d+\.\s/)) {
        return <h3 key={index} className='text-xl sm:text-2xl font-bold text-deepblue mt-8 mb-3'>{trimmedLine}</h3>;
      } else if (trimmedLine.startsWith('•')) {
        return (
          <div key={index} className='flex ml-4 sm:ml-8 mb-2 text-gray-700'>
            <span className='mr-2'>•</span>
            <p className='text-base leading-relaxed text-justify'>{trimmedLine.substring(1).trim()}</p>
          </div>
        );
      } else if (trimmedLine.startsWith('◦')) {
        return (
          <div key={index} className='flex ml-12 sm:ml-16 mb-2 text-gray-700'>
            <span className='mr-2'>◦</span>
            <p className='text-base leading-relaxed text-justify'>{trimmedLine.substring(1).trim()}</p>
          </div>
        );
      } else if (trimmedLine === 'Contact Information' || trimmedLine === 'Coordonnées') {
        return <h3 key={index} className='text-xl sm:text-2xl font-bold text-deepblue mt-8 mb-3'>{trimmedLine}</h3>;
      } else if (trimmedLine === '') {
        return null;
      } else {
        return <p key={index} className='mb-4 text-base text-gray-700 leading-relaxed text-justify'>{trimmedLine}</p>;
      }
    });
  };

  return (
    <div className='items-center w-full p-0 flex flex-col min-h-screen'>
      <img className='fixed top-0 left-0 w-full -z-50' src='img/ny.png' alt='background' />
      <div className='mt-[150px] w-full max-w-4xl mx-auto px-6 py-10 mb-40 bg-white/90 rounded-lg shadow-lg'>
        <h1 className='text-3xl sm:text-4xl font-bold mb-8 text-deepblue text-center uppercase tracking-wider'>{t('legalNotice.title')}</h1>
        <div>
          {renderContent(t('legalNotice.content'))}
        </div>

        <div className='mt-10 pt-8 border-t border-gray-300'>
          <h2 className='text-2xl font-bold mb-4 text-deepblue'>{t('legalNotice.disclosureTitle')}</h2>

          <ul className="list-disc pl-6 space-y-3 text-gray-800">

            <li>
              <a
                href="/pdf/Sustainability_note_1.pdf"
                download
                className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 underline"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                  />
                </svg>
                <span>{t('legalNotice.sfdrLink')}</span>
              </a>
            </li>

            <li>
              <strong className="text-blue-600">{t('legalNotice.remunerationPolicyTitle')}</strong>{" "}
              "{t('legalNotice.remunerationPolicyText')}"
            </li>

          </ul>

        </div>
      </div>
    </div>
  );
}

export default LegalNotice;
